import { KPIS, CLIENTS } from "@/data/mock";

export default function AdminDashboard() {
  return (
    <div className="space-y-10">
      <div>
        <div className="eyebrow">// Overview</div>
        <h1 className="display-lg text-silver-50 mt-2">Agency Command</h1>
      </div>

      <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-6">
        {KPIS.map((k) => (
          <div key={k.label} className="panel p-5">
            <div className="eyebrow">// {k.label}</div>
            <div className="mt-2 font-display font-extrabold text-3xl text-silver-50">{k.value}</div>
            <div className="mt-1 font-mono text-[10px] text-brand-blue uppercase tracking-widest">{k.delta}</div>
          </div>
        ))}
      </div>

      <div className="panel p-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="eyebrow">// At a glance</div>
            <h2 className="display-md text-silver-50 mt-1">Active Clients</h2>
          </div>
          <button className="btn-ghost">View all</button>
        </div>
        <div className="mt-5 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-silver-300">
                <th className="py-3 pr-4">Client</th>
                <th className="py-3 pr-4">Industry</th>
                <th className="py-3 pr-4">BSS</th>
                <th className="py-3 pr-4">Stage</th>
                <th className="py-3 pr-4">Directive</th>
                <th className="py-3 pr-4">Status</th>
                <th className="py-3 pr-4">CPL</th>
                <th className="py-3 pr-4">Trend</th>
              </tr>
            </thead>
            <tbody className="text-silver-100">
              {CLIENTS.map((c) => (
                <tr key={c.id} className="border-t border-ink-700/60">
                  <td className="py-3 pr-4 font-display font-semibold">{c.name}</td>
                  <td className="py-3 pr-4 text-silver-300">{c.industry}</td>
                  <td className="py-3 pr-4"><BssCell score={c.bss} /></td>
                  <td className="py-3 pr-4 font-mono">{c.stage}/11</td>
                  <td className="py-3 pr-4 text-silver-300">{c.directive}</td>
                  <td className="py-3 pr-4">{c.status}</td>
                  <td className="py-3 pr-4 font-mono">{c.cpl ? `$${c.cpl}` : "—"}</td>
                  <td className="py-3 pr-4 font-mono text-brand-blue">{c.trend}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function BssCell({ score }: { score: number }) {
  const color = score >= 75 ? "text-brand-blue" : score >= 60 ? "text-silver-200" : "text-brand-red";
  return <span className={`font-display font-bold ${color}`}>{score}</span>;
}
